import Checkbox from '@material-ui/core/Checkbox';
import { withStyles } from '@material-ui/core/styles';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import API_REST from '../../../api-rest-uruk';
import { config } from '../../../constants';
import { styles } from './styles';
import {
  Button,
  CircularProgress,
  FormControlLabel,
  FormGroup,
  TextField,
  Typography,
  Grid
} from '@material-ui/core';
import { AlertDialog } from '../../UI/AlertDialog';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { getUrlWithToken } from '../../../utils';

const AddIdentityDialog = (props) => {
  const { open, handleClose, classes, getAllIdentities, subgroup } = props;
  const [remoteOnBoarding, setRemoteOnBoarding] = useState(false);
  const [userId, setUserId] = useState('');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const [success, setSuccess] = useState(false);
  const [redirecting, setRedirecting] = useState(false);
  const [cancelCreationDialog, setCancelCreationDialog] = useState(false);
  const { t } = useTranslation();
  const userIdRegExp = new RegExp('^[A-Za-z0-9_.\\-:]*$');

  const onSubmit = async () => {
    setLoading(true);
    const body = {
      userId,
      subgroups: [subgroup]
    };

    if (remoteOnBoarding) {
      body.email = email;
    }

    API_REST.createOnBoarding(body)
      .then(async (response) => {
        if (!remoteOnBoarding) {
          const flowId = response.flowId;
          const stepId = response.stepId;
          const currentUrl = window.location.href;
          getUrlWithToken(`${config.FIRMA_FRONT_URL}/signUp/${flowId}/${stepId}?&urlCallback=${currentUrl}`);
          setRedirecting(true);
        } else {
          await getAllIdentities();
          setSuccess(true);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setErrorMessage(err.message);
        setLoading(false);
        setError(true);
      });
  };

  const checkUserIdRegex = async (e) => {
    if (userIdRegExp.test(e)) {
      setUserId(e);
    }
  };

  return (
    <Grid container justify='center' alignItems='center'>
      <Grid item lg={6} md={10} sm={10} sx={12} className={classes.mainGrid}>
        <div onClose={handleClose} open={open}>
          <Typography variant='h5'>
            {t('addIdentityDialog:createOnboarding')}
          </Typography>
          {loading ? (
            <div className={classes.mainLoading}>
              <CircularProgress />
            </div>
          ) : (
            <>
              {redirecting && (
                <div className={classes.redirectingContainer}>
                  <Typography variant='body2'>
                    {t('addIdentityDialog:redirectingToSignProcess')}
                  </Typography>
                  <CircularProgress style={{ marginTop: '20px' }} />
                </div>
              )}
              {success && (
                <div className={classes.messageContainer}>
                  <Typography variant='body2'>
                    {t('addIdentityDialog:processStarted')}
                  </Typography>
                </div>
              )}
              {error && (
                <div className={classes.messageContainer}>
                  <Typography variant='body2'>
                    {t(`addIdentityDialog:${errorMessage}`) === `addIdentityDialog:${errorMessage}`
                      ? t('addIdentityDialog:thereWasAnError') : t(`addIdentityDialog:${errorMessage}`)}
                  </Typography>
                </div>
              )}
              {!error && !success && !redirecting && (
                <FormGroup>
                  <TextField
                    required
                    id='userId'
                    label={t('addIdentityDialog:idNumber')}
                    value={userId}
                    onChange={(e) => checkUserIdRegex(e.target.value)}
                    defaultValue=''
                    className={classes.textField}
                    margin='normal'
                    variant='filled'
                  />
                  {remoteOnBoarding && (
                    <TextField
                      required
                      id='email'
                      label='Email'
                      value={email}
                      className={classes.textField}
                      onChange={(e) => setEmail(e.target.value)}
                      margin='normal'
                      variant='filled'
                    />
                  )}
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={remoteOnBoarding}
                        onChange={() => setRemoteOnBoarding((s) => !s)}
                        name='RemoteOnBoarding'
                        color='primary'
                      />
                    }
                    label={t('addIdentityDialog:remote')}
                  />
                </FormGroup>
              )}
            </>
          )}
          {!success && !error && (
            <div className={classes.buttonContainer}>
              <Button className={classes.btn_margin} autoFocus onClick={() => setCancelCreationDialog(true)} color='primary'>
                {t('addIdentityDialog:cancel')}
              </Button>
              <Button className={classes.btn_margin} autoFocus variant='contained' onClick={onSubmit} color='primary'>
                {t('addIdentityDialog:send')}
              </Button>
            </div>
          )}
          {(success || error) && (
            <Button
              autoFocus
              className={classes.btn_margin}
              onClick={() => {
                setSuccess(false);
                handleClose();
              }}
              color='primary'
            >
              {t('addIdentityDialog:close')}
            </Button>
          )}
          {error && (
            <Button
              autoFocus
              className={classes.btn_margin}
              variant='contained'
              onClick={() => {
                setError(false);
              }}
              color='primary'
            >
              {t('addIdentityDialog:retry')}
            </Button>
          )}
        </div>
      </Grid>
      {cancelCreationDialog &&
        <AlertDialog
          description={t('addIdentityDialog:cancelMessage')}
          callbackFunc={handleClose}
          open={cancelCreationDialog}
          setOpen={setCancelCreationDialog}
        />}
    </Grid>
  );
};

const mapStateToProps = (state) => {
  return {
    subgroup: state.config.subgroup
  };
};

AddIdentityDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  getAllIdentities: PropTypes.object.isRequired,
  subgroup: PropTypes.string.isRequired,
  open: PropTypes.object.isRequired,
  handleClose: PropTypes.object.isRequired
};

export default connect(mapStateToProps, null)(withStyles(styles)(AddIdentityDialog));
